import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Password from './Password';
import { setCaseStudyAuthenticated } from '../../utils/caseStudyAuth';

/**
 * Standalone guest area page — no header, no footer. Just the password form.
 * On success: sets session auth and navigates to ?redirect= or home.
 */
export default function PasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const redirectTo = searchParams.get('redirect') || '/';

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.classList.add('guest-area-active');
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.classList.remove('guest-area-active');
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  const authenticate = () => {
    setCaseStudyAuthenticated();
    navigate(redirectTo, { replace: true });
  };

  return (
    <div className="guest-area-page">
      <Password authenticate={authenticate} embedded={false} />
    </div>
  );
}
